import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'dialog-confirm',
    templateUrl: 'dialog.confirm.html',
})
export class ConfirmLogOutDialog {

    constructor(
        public dialogRef: MatDialogRef<ConfirmLogOutDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    onNoClick(): void {
        this.dialogRef.close();
    }

}